/**
 * 将“美元”格式的字符串转换为整数美分，便于后端或数据库存储。
 * 例如 "1.23" → 123，超过两位小数时四舍五入。
 */
export const parseDecimalStringToCents = (value: string): number => {
    const num = parseFloat(value) || 0;
    return Math.round(num * 100);
};

/**
 * 将后端存储的美分数值格式化为前端展示的两位小数字符串（美元）。
 * 如果输入为空，则返回空字符串，以便区分“未填写”和“0.00”。
 */
export const formatCentsToDecimalString = (cents: number | undefined | null): string => {
    if (cents === null || cents === undefined) {
        return '';
    }
    return (cents / 100).toFixed(2);
};

/**
 * 清洗用户输入的“美元”字符串：去掉非数字/小数点字符，限制最多一个小数点和两位小数。
 */
export const sanitizeDecimalInput = (value: string): string => {
    const sanitized = value.replace(/[^\d.]/g, '');
    const parts = sanitized.split('.');
    if (parts.length > 2) {
        return parts[0] + '.' + parts.slice(1).join('');
    }
    if (parts.length === 2) {
        return parts[0] + '.' + parts[1].slice(0, 2);
    }
    return sanitized;
};
